module.exports = __webpack_public_path__ + "img/baby_lying_flipped.f50b8d65.svg";